// Vue 3 replacement for `vuetify-confirm` (which has no Vue 3 port).
//
// A single reactive state object drives one <ConfirmDialog /> rendered in
// App.vue. `confirm()` returns a Promise<boolean> that resolves when the user
// answers, matching the old `this.$confirm(message, options)` contract so call
// sites only needed their access path swapped, not their arguments.
import { reactive } from 'vue';

export interface ConfirmOptions {
    title?: string;
    buttonTrueText?: string;
    buttonFalseText?: string;
    color?: string | null;
    width?: number;
    icon?: string;
}

interface ConfirmState {
    show: boolean;
    message: string;
    options: ConfirmOptions;
    resolve: ((value: boolean) => void) | null;
}

export const confirmState = reactive<ConfirmState>({
    show: false,
    message: '',
    options: {},
    resolve: null,
});

export function confirm(message: string, options: ConfirmOptions = {}): Promise<boolean> {
    // Resolve any dialog that was already open (mirrors single-dialog behaviour).
    if (confirmState.resolve) {
        confirmState.resolve(false);
    }
    confirmState.message = message;
    confirmState.options = options;
    confirmState.show = true;
    return new Promise<boolean>((resolve) => {
        confirmState.resolve = resolve;
    });
}

export function answerConfirm(value: boolean): void {
    confirmState.show = false;
    const resolve = confirmState.resolve;
    confirmState.resolve = null;
    if (resolve) {
        resolve(value);
    }
}
